import type { FC } from "react"
import { IconUrlContainer, type IconUrlContainerProps } from "./IconUrlContainer"

export type IconUrlsProps = Omit<IconUrlContainerProps, "url">
export type IconUrl = FC<IconUrlsProps>

export const CashIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/cash.svg" {...props} />
)

export const ClockWarningIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/clock-warning.svg" {...props} />
)

export const MegaphoneIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/megaphone.svg" {...props} />
)

export const PhotoClickIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/photo-click.svg" {...props} />
)

export const StarPlusIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/star-plus.svg" {...props} />
)

export const ExpiredProductsIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/expired-products.svg" {...props} />
)

export const UserCheckIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/user-check.svg" {...props} />
)

export const FolderIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/folder.svg" {...props} />
)

export const ClockIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/clock.svg" {...props} />
)

export const CheckIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/check.svg" {...props} />
)

export const CheckCircleIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/checkCircle.svg" {...props} />
)

export const CheckCircleThinBorderIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/checkCircleThinBorder.svg" {...props} />
)

export const RefreshIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/refresh.svg" {...props} />
)

export const XIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/x.svg" {...props} />
)

export const XCircleIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/xCircle.svg" {...props} />
)

export const NoRdvIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/Icon_NO_RDV.svg" {...props} />
)

export const CatalogIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/catalog.svg" {...props} />
)

export const SendCircleIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/circle-send.svg" {...props} />
)

export const DotIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/dot.svg" {...props} />
)

export const CloudIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/cloud.svg" {...props} />
)

export const HalfPersonIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/half-person.svg" {...props} />
)

export const ShieldIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/security.svg" {...props} />
)

export const ArrowDownRightIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/down-right-arrow.svg" {...props} />
)

export const UserBubbleIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/user-bubble.svg" {...props} />
)

export const PillsIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/pills.svg" {...props} />
)

export const MedicinesIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/medicines.svg" {...props} />
)

export const BlisterMedicineIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/blister-medecine.svg" {...props} />
)

export const FamilyIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/family.svg" {...props} />
)

export const BabyIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/baby.svg" {...props} />
)

export const HeartRateIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/heart-rate.svg" {...props} />
)

export const HygieneIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/hygiene.svg" {...props} />
)

export const MedicalDeviceIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/medical-device.svg" {...props} />
)

export const LeafIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/leaf.svg" {...props} />
)

export const PawIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/paw.svg" {...props} />
)

export const ConicalFlaskIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/conical-flask.svg" {...props} />
)

export const PadlockIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/padlock.svg" {...props} />
)

export const SyringeIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/syringe.svg" {...props} />
)

export const CreditCardIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/credit-card.svg" {...props} />
)

export const MinusCircleThinBorderIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/minusCircleThinBorder.svg" {...props} />
)

export const MinusCircleIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/minusCircle.svg" {...props} />
)

export const SearchIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/search.svg" {...props} />
)

export const OpenFolderIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/openXFolder.svg" {...props} />
)

export const BookmarkTodoIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/bookmarkTodo.svg" {...props} />
)

export const CalendarIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/calendar.svg" {...props} />
)

export const HandshakeIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/handshake.svg" {...props} />
)

export const PlugsIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/plugs.svg" {...props} />
)

export const EuroBiftonIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/euroBifton.svg" {...props} />
)

export const PriceTagIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/priceTag.svg" {...props} />
)

export const CardboardBoxIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/cardboardBox.svg" {...props} />
)

export const MicroscopeIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/microscope.svg" {...props} />
)

export const HeartIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/heart.svg" {...props} />
)

export const CreamIcon: IconUrl = (props: IconUrlsProps) => (
  <IconUrlContainer url="/icons/cream.svg" {...props} />
)
